import { axiosInstance } from '../../../api/axios-instance';
import type { PaginatedResult } from '../../../types/common';

/**
 * Admin Task Runs stack — hits the bagel-admin `/admin/integration-tasks` endpoint.
 * Kept separate from the lifted (dashboard) `integrations2.0.ts`, whose customer-path
 * `getIntegrationTasks`/`IntegrationTask` would otherwise collide with these.
 */
export interface AdminIntegrationTask {
  _id: string;
  accountId: string;
  origin: string;
  objectName?: string;
  type?: string;
  options?: {
    objectName?: string;
    startDate?: string;
    endDate?: string;
    dateField?: string;
  };
  execution?: {
    status?: string;
    startDate?: string;
    finishDate?: string;
    stats?: {
      apiCallCount?: number;
      receivedCount?: number;
      processedCount?: number;
    };
  };
  lastModified?: string;
  createdAt?: string;
}

export const getAdminIntegrationTasks = async (
  accountId: string,
  integrationKey: string,
  page = 1,
  pageSize = 20,
  status?: string,
  objectName?: string,
): Promise<PaginatedResult<AdminIntegrationTask>> => {
  const params: Record<string, string | number> = {
    accountId,
    integrationKey,
    page,
    pageSize,
    sortBy: 'lastModified',
    sortDir: 'desc',
  };
  if (status) params.status = status;
  if (objectName) params.objectName = objectName;
  const res = await axiosInstance.get<PaginatedResult<AdminIntegrationTask>>(
    '/admin/integration-tasks',
    { params },
  );
  return res.data;
};
